import React, { Component } from "react";
import thousandsFormat from "@/modules/thousandsFormat";
import "./index.scss";

interface IProps {
	bet: number;
	langStr: string;
}

export default class Tooltip extends Component<IProps> {
	render() {
		return this.props.bet ? (
			<div className="sl-tooltip">
				{thousandsFormat(this.props.bet, this.props.langStr)}
			</div>
		) : null;
	}
}
